module.exports = __webpack_public_path__ + "img/process.d283c706.jpg";